var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"regions"},[_c('h1',[_vm._v("Coach Tour Pickup Points")]),_c('PickupPoints')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }